angular.module('app').controller('UserCtrl', function($controller, $scope, $mdDialog) {
    "ngInject";

    var main = this;

    main.name = 'user';
    main.newCert = {};

    angular.extend(main, $controller('ItemCtrl', {'$scope': $scope, 'main': main}));

    $scope.$on('model-loaded', function() {
        if(main.item.address_id === null) {
            delete main.item.address_id;
        }
    });
});
